const initialState = {
	UserID: "",
	Username: "",
	UserEmail: "",
	FirstName:"",
	Permissions: []
};

const state = JSON.parse(JSON.stringify(initialState));

const actions = {};

const mutations = {
	setUserDetails(state, payload) {
		payload = payload.value;

		try {
			state.UserID = payload.UserID;
			state.Username = payload.Username;
			state.UserEmail = payload.UserEmail;
			state.Permissions = payload.Permissions;
			state.FirstName = payload.FirstName;
		} catch (e) {
			console.log(e.message);
		}
	},
	resetState(state) {
		state.UserID = initialState.UserID;
		state.Username = initialState.Username;
		state.UserEmail = initialState.UserEmail;
		state.Permissions = initialState.Permissions;
	}
};
const getters = {};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions
};
